import { createAPIMethod } from 'utils/generic.ts';
import {
	normalizeWatchdog,
	normalizeWatchdogCount,
	normalizeWatchdogsSummary,
	type RequestCreateWatchdog,
	type ResponseCreateWatchdog,
	type WatchdogCountData,
	type WatchdogData,
	type WatchdogsSummary,
} from 'service/watchdog/model.ts';

export const WATCHDOG_MAX_AMOUNT = 20;

export async function createWatchdog(filter: RequestCreateWatchdog, headers?: HeadersInit) {
	return createAPIMethod<RequestCreateWatchdog, ResponseCreateWatchdog>({
		path: `/users/self/watchdogs`,
		method: 'POST',
		skipResponseParsing: true,
		headers,
	})(filter);
}

export async function updateWatchdog(watchdogId: number, filter: RequestCreateWatchdog, headers?: HeadersInit) {
	return createAPIMethod<RequestCreateWatchdog, void>({
		path: `/users/self/watchdogs/${watchdogId}`,
		method: 'PATCH',
		skipResponseParsing: true,
		headers,
	})(filter);
}

export async function removeWatchdog(watchdogId: number, headers?: HeadersInit) {
	return createAPIMethod<{ advert_id: string }, void>({
		path: `/users/self/watchdogs/${watchdogId}`,
		method: 'DELETE',
		skipResponseParsing: true,
		headers,
	})();
}

export async function getWatchdog(watchdogId: number, headers?: HeadersInit) {
	return createAPIMethod<object, WatchdogData>({
		path: `/users/self/watchdogs/${watchdogId}`,
		method: 'GET',
		normalize: ({ result }) => normalizeWatchdog(result),
		headers,
	})();
}

export async function getWatchdogs(headers?: HeadersInit) {
	return createAPIMethod<object, WatchdogData[]>({
		path: `/users/self/watchdogs`,
		method: 'GET',
		normalize: ({ results }) => results.map(normalizeWatchdog),
		headers,
	})();
}

// todo: the endpoint does not exist yet, awaiting BE implementation: https://youtrack.seznam.net/issue/SBA-838/Prejit-na-watchdogs-counts-id
export async function getWatchdogCount(watchdogId: number, headers?: HeadersInit) {
	return createAPIMethod<object, WatchdogCountData>({
		path: `/users/self/watchdogs/counts/${watchdogId}`,
		method: 'GET',
		normalize: ({ result }) => normalizeWatchdogCount(result),
		headers,
	})();
}

export async function getWatchdogsCounts(headers?: HeadersInit, abortController?: AbortController) {
	return createAPIMethod<object, WatchdogCountData[]>({
		path: `/users/self/watchdogs/counts`,
		method: 'GET',
		normalize: ({ results }) => results.map(normalizeWatchdogCount),
		headers,
		abortController,
	})();
}

export async function getWatchdogsSummary(headers?: HeadersInit) {
	return createAPIMethod<object, WatchdogsSummary>({
		path: `/users/self/watchdogs/summary`,
		method: 'GET',
		normalize: ({ result }) => normalizeWatchdogsSummary(result),
		headers,
	})();
}
